import { render } from "./PlayerList.vue?vue&type=template&id=5b4137a4&scoped=true&ts=true"
import script from "./PlayerList.vue?vue&type=script&lang=ts"
export * from "./PlayerList.vue?vue&type=script&lang=ts"

import "./PlayerList.vue?vue&type=style&index=0&id=5b4137a4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4137a4"]])

export default __exports__